import Swiper, { Navigation, Lazy, Pagination } from "swiper";
import Video from "../modules/video";
import helpers from "../utils/helpers";
import Training from "./template-training";

const SingleService = {
  init() {
    SingleService.events();
    SingleService.legalPerson();
    SingleService.fixLineWidth();
    SingleService.videoSlider();
    Video.init();
  },

  events() {
    $(".btn-gallery-type").on("click", (e) => {
      SingleService.handleGalleryType(e.currentTarget);
    });
    $(".btn-training-type").on("click", (e) =>
      Training.handleTrainingType(e.currentTarget)
    );

    $("#service-form").on("submit", (e) => {
      e.preventDefault();
      SingleService.serviceValidate();
    });

    $("#legal-form").on("submit", (e) => {
      e.preventDefault();
      SingleService.legalValidate();
    });
  },

  legalPerson() {
    const personsWrapEl = $("#legal-persons");
    const personHtml = personsWrapEl.html();

    // Add person
    $(".legal-form-add-person").on("click", function () {
      // Add max 7 items
      if (personsWrapEl.children(".person").length > 6) {
        return;
      }

      personsWrapEl.append(personHtml);

      // show/hide remove button
      if (personsWrapEl.children(".person").length > 1) {
        personsWrapEl.find(".legal-form-remove-person").removeClass("hidden");
      } else {
        $(".legal-form-remove-person").addClass("hidden");
      }
    });

    // Remove person
    personsWrapEl.on("click", ".legal-form-remove-person", function () {
      $(this).closest(".person").remove();

      // show/hide remove button
      if (personsWrapEl.children(".person").length > 1) {
        personsWrapEl.find(".legal-form-remove-person").removeClass("hidden");
      } else {
        personsWrapEl.find(".legal-form-remove-person").addClass("hidden");
      }
    });
  },

  fixLineWidth() {
    const btnWidth = this.getButtonWidth($(".btn-gallery-type.active"));
    const line = $(".gallery-types .line");

    line.css({ width: `${btnWidth}px` });
  },

  handleGalleryType(clickedButton) {
    const btn = $(clickedButton);

    if (btn.hasClass("active")) {
      return;
    }

    const line = $(".gallery-types .line");

    $(".btn-gallery-type").each((idx, button) => {
      $(button).removeClass("active");

      if (clickedButton.isEqualNode(button)) {
        $(button).addClass("active");
      }
    });

    const btnWidth = SingleService.getButtonWidth(clickedButton);
    const containerWidth = $(".gallery-types").innerWidth();

    line.css({ width: `${btnWidth}px` });

    if (btn.hasClass("btn-gallery-type--video")) {
      line.css({ transform: `translateX(${containerWidth - btnWidth}px)` });
      $(".news-photo-gallery").addClass("hidden");
      $(".news-video-gallery").removeClass("hidden");
    } else {
      line.css({ transform: "translateX(0px)" });
      $(".news-photo-gallery").removeClass("hidden");
      $(".news-video-gallery").addClass("hidden");

      $(".swiper-wrapper video").each((idx, vid) => {
        vid.pause();
        $(vid).closest(".video").find(".video__overlay").fadeIn(200);
      });
    }
  },

  getButtonWidth(btn) {
    return $(btn).innerWidth();
  },

  videoSlider() {
    const videoEl = $(".news-video-gallery");

    const swiper = new Swiper(videoEl.find(".video-slider")[0], {
      modules: [Lazy, Navigation, Pagination],
      loop: true,
      spaceBetween: 38,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: videoEl.find(".swiper-button-prev")[0],
        nextEl: videoEl.find(".swiper-button-next")[0],
      },
      pagination: {
        el: videoEl.find(".swiper-pagination")[0],
        clickable: true,
        type: "bullets",
      },
    });

    swiper.on("slideChange", () => {
      videoEl.find(".swiper-slide-active video")[0].pause();
      videoEl.find(".video__overlay").fadeIn(200);
    });
  },

  serviceValidate() {
    const formEl = $("#service-form");
    formEl.addClass("loading");

    $(".error", this).removeClass("error");

    if (helpers.validate(formEl)) {
      setTimeout(() => {
        SingleService.serviceRecaptcha();
      }, 500);
    } else {
      formEl.removeClass("loading");
      const erInp = formEl.find(".error");
      erInp.toArray().forEach((input) => {
        $(input).parent().parent().addClass("row-w-error");
      });
    }
  },

  serviceRecaptcha() {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        SingleService.serviceSubmit(token);
      });
    });
  },

  serviceSubmit(token) {
    const formEl = $("#service-form");

    const formData = new FormData(formEl[0]);

    formData.append("token", token);

    formEl.find("button").addClass("loading");
    formEl.find(".form-status").addClass("hidden");

    const thankYouURL = "/paldies";

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        if (response.success) {
          formEl[0].reset();
          formEl.find(".errors-wrap").remove();
          formEl.find(".form-status").removeClass("error");
          window.location.href = thankYouURL;
        } else {
          formEl.find(".form-status").addClass("error");
        }

        formEl
          .find(".form-status")
          .text(response.data.message)
          .removeClass("hidden");
      })
      .always(() => {
        formEl.removeClass("loading");
        formEl.find("button").removeClass("loading");
      });
  },

  legalValidate() {
    const formEl = $("#legal-form");
    formEl.addClass("loading");

    $(".error", this).removeClass("error");

    if (helpers.validate(formEl)) {
      setTimeout(() => {
        SingleService.legalRecaptcha();
      }, 500);
    } else {
      formEl.removeClass("loading");
      const erInp = formEl.find(".error");
      erInp.toArray().forEach((input) => {
        $(input).parent().parent().addClass("row-w-error");
      });
    }
  },

  legalRecaptcha() {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        SingleService.legalSubmit(token);
      });
    });
  },

  legalSubmit(token) {
    const formEl = $("#legal-form");

    const formData = new FormData(formEl[0]);

    formData.append("token", token);

    formEl.find("button").addClass("loading");
    formEl.find(".form-status").addClass("hidden");

    const thankYouURL = "/paldies";

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        if (response.success) {
          formEl[0].reset();
          formEl.find(".errors-wrap").remove();
          formEl.find(".form-status").removeClass("error");
          window.location.href = thankYouURL;
        } else {
          formEl.find(".form-status").addClass("error");
        }

        formEl
          .find(".form-status")
          .text(response.data.message)
          .removeClass("hidden");
      })
      .always(() => {
        formEl.removeClass("loading");
        formEl.find("button").removeClass("loading");
      });
  },
};

export default SingleService;
